'use client';

import Link from 'next/link';
import { Sofa, Home, LampDesk, Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';

export default function FurnitureComingSoonPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#0e0e0e] text-white px-4 text-center pt-20 pb-28">
      {/* Gradient Heading */}
      <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-[#d4af37] via-white to-[#d4af37] bg-clip-text text-transparent mb-4">
        Furniture Collection Coming Soon
      </h1>

      {/* Subheading */}
      <p className="text-lg md:text-xl text-gray-300 max-w-xl mb-8">
        Solusi Design is crafting elegant furniture pieces that elevate your space. A new chapter in home interiors is on the way.
      </p>



      {/* Spacer */}
      <div className="h-20" />

      {/* Icon Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-16">
        <div className="flex items-center justify-center gap-3 text-gray-200">
          <Sofa className="w-6 h-6 text-[#d4af37]" />
          <span>Luxury Sofas</span>
        </div>
        <div className="flex items-center justify-center gap-3 text-gray-200">
          <LampDesk className="w-6 h-6 text-[#d4af37]" />
          <span>Ambient Lighting</span>
        </div>
        <div className="flex items-center justify-center gap-3 text-gray-200">
          <Home className="w-6 h-6 text-[#d4af37]" />
          <span>Modern Interiors</span>
        </div>
      </div>

      {/* Social Icons with Text */}
      <div className="flex flex-wrap justify-center items-center gap-12 text-sm text-gray-400">
        <Link href="https://www.instagram.com/solusidesigns/" target="_blank" className="flex items-center hover:text-[#d4af37] transition-all">
          <Instagram className="w-5 h-5 mr-2" /> Instagram
        </Link>
        <Link href="https://www.facebook.com/solusidesigns" target="_blank" className="flex items-center hover:text-[#d4af37] transition-all">
          <Facebook className="w-5 h-5 mr-2" /> Facebook
        </Link>
        <Link href="https://www.linkedin.com/company/solusi-designs/" target="_blank" className="flex items-center hover:text-[#d4af37] transition-all">
          <Linkedin className="w-5 h-5 mr-2" /> LinkedIn
        </Link>
        <Link href="#" target="_blank" className="flex items-center hover:text-[#d4af37] transition-all">
          <Youtube className="w-5 h-5 mr-2" /> YouTube
        </Link>
      </div>
    </div>
  );
}
